import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const programs = [{
  name: 'Little Tigers',
  age: 'Ages 3-5',
  description: 'The perfect start for your little one. We focus on motor skills, listening, and fun in a safe environment.',
  features: ['Improve Coordination', 'Learn Respect', 'Burn Energy', 'Safety Awareness'],
  image: 'https://cdn.magicpatterns.com/uploads/4YaBERmsiWTmZKsS1bpsGS/littletigers.jpg',
  highlight: false
}, {
  name: 'Kids & Teens',
  age: 'Ages 6-17',
  description: 'Building strong character through martial arts. Confidence, discipline, and fitness for growing bodies and minds.',
  features: ['Better Focus', 'Anti-Bullying', 'Goal Setting', 'High School Credit'],
  image: 'https://cdn.magicpatterns.com/uploads/fbY8VVjDhUruma9wa6z2DD/teens.jpg',
  highlight: true
}, {
  name: 'Adults',
  age: 'Ages 18+',
  description: "It's never too late to start. Get in the best shape of your life while learning practical self-defense skills.",
  features: ['Stress Relief', 'Functional Fitness', 'Self-Defense', 'Community'],
  image: 'https://images.unsplash.com/photo-1552072092-7f9b8d63efcb?q=80&w=2070&auto=format&fit=crop',
  highlight: false
}];
export function ProgramsSection() {
  return <section id="programs" className="py-24 bg-[#1a1a1a] text-white" data-id="element-232">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-233">
        <div className="flex flex-col md:flex-row justify-between items-end mb-16 gap-6" data-id="element-234">
          <div className="max-w-2xl" data-id="element-235">
            <h2 className="text-3xl md:text-5xl font-bold mb-4" data-id="element-236">
              Programs For Every Age
            </h2>
            <div className="w-20 h-1 bg-[#00D4FF] mb-6" data-id="element-237" />
            <p className="text-gray-400 text-lg" data-id="element-238">
              Whether you're looking to build confidence in your child or get
              fit yourself, we have a program designed for your specific goals.
            </p>
          </div>
          <a href="#schedule" className="text-[#00D4FF] font-bold uppercase tracking-wider hover:text-white transition-colors flex items-center gap-2" data-id="element-239">
            View Full Schedule <span aria-hidden="true" data-id="element-240">&rarr;</span>
          </a>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-241">
          {programs.map((program, index) => <motion.div key={program.name} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} className={`relative rounded-2xl overflow-hidden group ${program.highlight ? 'ring-2 ring-[#00D4FF] shadow-[0_0_30px_rgba(0,212,255,0.15)]' : 'border border-gray-800'}`} data-id="element-242">
              {/* Image Header */}
              <div className="h-48 overflow-hidden relative" data-id="element-243">
                <div className="absolute inset-0 bg-black/40 group-hover:bg-black/20 transition-colors z-10" data-id="element-244" />
                <img src={program.image} alt={program.name} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" data-id="element-245" />
                <div className="absolute bottom-4 left-4 z-20" data-id="element-246">
                  <span className="inline-block px-3 py-1 bg-[#00D4FF] text-black text-xs font-bold uppercase tracking-wider rounded-full mb-2" data-id="element-247">
                    {program.age}
                  </span>
                  <h3 className="text-2xl font-bold text-white" data-id="element-248">
                    {program.name}
                  </h3>
                </div>
              </div>

              {/* Content */}
              <div className="p-6 bg-[#222]" data-id="element-249">
                <p className="text-gray-400 mb-6 min-h-[80px]" data-id="element-250">
                  {program.description}
                </p>

                <ul className="space-y-3 mb-8" data-id="element-251">
                  {program.features.map(feature => <li key={feature} className="flex items-start gap-3 text-sm text-gray-300" data-id="element-252">
                      <Check className="w-5 h-5 text-[#00D4FF] shrink-0" data-id="element-253" />
                      {feature}
                    </li>)}
                </ul>

                <button className="w-full py-3 rounded border border-gray-600 text-white font-bold uppercase tracking-wider hover:bg-white hover:text-black transition-colors" data-id="element-254">
                  Learn More
                </button>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}